// Show only one toast at a time across the whole app.
// Every toast.success / error / info / warn / warning call first dismisses
// whatever toast is on screen, so repeated taps (e.g. VERIFY with a wrong
// OTP) replace the toast instead of stacking copies of it.
// Imported once in src/index.js.
import { toast } from "react-toastify";

["success", "error", "info", "warn", "warning"].forEach((type) => {
  const show = toast[type];
  toast[type] = (content, options) => {
    toast.dismiss();
    return show(content, options);
  };
});
